import React from "react";

import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { MdmDeviceDto } from "gql/generated/types";
import { sample } from "lodash-es";
import { Tag } from "primereact/tag";
import { STATUS_UPDATE_TIME } from "../utils/const";

const DeviceStatus: React.FC<{device: MdmDeviceDto}> = ({device}) => {

  const randomDataset = sample(device.boundDatasets?.all);
  if (!randomDataset) return null;
  return <DatasetStatus identifier={randomDataset.identifier!} threshold={device.config?.vitalityThreshold!}/>;
}

const DatasetStatus: React.FC<{identifier: string, threshold?: number}> = ({identifier, threshold = 1}) => {
  const { data, dataUpdatedAt } = useGetRecentData([identifier], {
    count: 1,
    options: { refetchInterval: STATUS_UPDATE_TIME },
  });

  if (!data) return null;
  
  const vitality = dataUpdatedAt - new Date(data[0].data[0]?.key).getTime()
  
  if (vitality && vitality > threshold * 1000) {
    return <Tag value="Offline" severity="danger" />;
  }
  if (vitality && vitality > 0) {
    return <Tag value="Online" severity="success" />;
  }
  return <Tag value="No Data" severity="danger" />;
}

export default DeviceStatus;